// 매장 코드 → 표시 라벨. 백엔드는 코드(BUSAN/GWANGJU ...)만 내려주므로
// 화면 표기는 여기서 매핑한다. 새 매장이 생기면 여기에 라벨만 추가하면 되고,
// 매핑이 없으면 코드를 그대로 보여 준다(깨지지 않게).
const STORE_LABELS: Record<string, string> = {
  BUSAN:   '부산점',
  GWANGJU: '광주점',
};

export function storeLabel(code: string): string {
  // 응답마다 대소문자가 달라(hub-changes 의 store 는 'gwangju') 코드 그대로 "gwangju 가격" 으로 보였다(감사 card-controltower#440).
  return STORE_LABELS[code.trim().toUpperCase()] ?? code;
}

/**
 * 화면 용어 — PriceHub 의 매장별 가격을 "<매장> 가격"(예: "광주 가격")으로 부른다(감사 card-controltower#328, 사장 결정
 * 2026-10-27). 매장 라벨 끝의 "점" 을 뺀다. 매장을 모르면 "매장 가격". PriceHub 공통가는 "PriceHub 가격".
 */
export function storePriceLabel(code?: string | null): string {
  if (!code) return '매장 가격';
  return `${storeLabel(code).replace(/점$/, '')} 가격`;
}
